import { TMessageSchema } from '../../types/messages';
import { ITypedReduxAction } from '../../types/redux/actionType';

export enum ESendMessageActionTypes {
  SetFailed = 'sendMessage/failed',
  SetSuccess = 'sendMessage/success',
  SetPending = 'sendMessage/pending',
  SetAbort = 'sendMessage/abort',
  SetFirstMessageSuccess = 'sendMessage/firstMessageSuccess',
}

export interface ISendMessagePayload {
  message: TMessageSchema;
  messageId: string;
}

export interface ISendFirstMessagePayload {
  message: TMessageSchema;
}

export type TSendMessageActions =
  | ITypedReduxAction<ESendMessageActionTypes.SetFailed, ISendMessagePayload>
  | ITypedReduxAction<ESendMessageActionTypes.SetSuccess, ISendMessagePayload>
  | ITypedReduxAction<ESendMessageActionTypes.SetPending, ISendMessagePayload>
  | ITypedReduxAction<ESendMessageActionTypes.SetAbort, ISendMessagePayload>
  | ITypedReduxAction<ESendMessageActionTypes.SetFirstMessageSuccess, ISendFirstMessagePayload>;
